import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import { ClientSentryIgnoreRule } from '@/shared/utils/sentry/clientIgnoreRules/types';

const MASKED_URL_REFERENCE_ERROR_MESSAGE = "can't find variable: _0x4761";
const WEBKIT_MASKED_URL_FRAME = 'webkit-masked-url://hidden/';
const SELLER_UI_APP_FRAME_MARKERS = [
  'webpack://_n_e/./src/',
  'webpack://_n_e/src/',
  'webpack://_n_e/./pages/',
  'webpack://_n_e/pages/',
  '/_next/static/chunks/',
] as const;

const hasMaskedUrlReferenceErrorMessage = (message: unknown): boolean =>
  toNormalizedMessage(message) === MASKED_URL_REFERENCE_ERROR_MESSAGE;

const hasWebkitMaskedUrlStackFrame = (
  stackFrameFilenames: readonly string[]
): boolean =>
  stackFrameFilenames.some(
    (filename) => toNormalizedMessage(filename) === WEBKIT_MASKED_URL_FRAME
  );

const hasSellerUiAppStackFrame = (
  stackFrameFilenames: readonly string[]
): boolean =>
  stackFrameFilenames.some((filename) => {
    const normalizedFilename = toNormalizedMessage(filename);

    return Boolean(
      normalizedFilename &&
      SELLER_UI_APP_FRAME_MARKERS.some((marker) =>
        normalizedFilename.includes(marker)
      )
    );
  });

export const thirdPartyMaskedUrlReferenceErrorRule: ClientSentryIgnoreRule = {
  id: 'third-party-masked-url-reference-error',
  references: ['FTR-3282'],
  reason:
    'Known Safari masked third-party script ReferenceError with no seller-ui source context',
  matches: ({
    firstExceptionType,
    originalExceptionMessage,
    serializedMessage,
    stackFrameFilenames,
  }) => {
    if (firstExceptionType !== 'ReferenceError') {
      return false;
    }

    if (
      !hasMaskedUrlReferenceErrorMessage(serializedMessage) &&
      !hasMaskedUrlReferenceErrorMessage(originalExceptionMessage)
    ) {
      return false;
    }

    if (hasSellerUiAppStackFrame(stackFrameFilenames)) {
      return false;
    }

    return hasWebkitMaskedUrlStackFrame(stackFrameFilenames);
  },
};
